// =============================================
// src/components/Hero.tsx
// =============================================
import React from 'react';
import { Typography } from '@mui/material';
import bgImg from './img.png'


const Hero: React.FC = () => {

  return (
      <div style={{
        minHeight: '80vh',
        backgroundColor: 'inherit',
        backgroundImage: `url(${bgImg}`,
        backgroundPosition: 'center',      // ← completely centered
        backgroundSize: 'cover',           // fills the area nicely
        backgroundRepeat: 'no-repeat',  
      }}>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            padding: '40px',
            paddingTop:'40vh'
          }}>
            <div style={{
                flexGrow: 1
            }}></div>
            <Typography
              variant="h1"
              sx={{ mb: 2, color: 'text.primary',  }}
            >
              Route Royale
            </Typography>
            <Typography
              variant="h4"
              sx={{
                mb: 4,
                maxWidth: 500,
                color: 'text.secondary',
              }}
            >
              Luxury Transportation for Every Occasion
            </Typography>
            
          </div>
      </div>   
  );
};

export default Hero;